module.exports = "/_next/static/images/facebook-c-icon-da63591962a3fe42c084902c018ae3b4.svg";